module.exports = __webpack_public_path__ + "static/media/wrl-logo.f9973d4c.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/wrl-logo.png
// module id = 1215
// module chunks = 0